import { Component } from '@angular/core';

@Component({
	selector: 'seira-previsao-numerica-tempo',
	templateUrl: './previsao-numerica-tempo.component.html',
	styleUrls: ['./previsao-numerica-tempo.component.scss'],
})
export class PrevisaoNumericaTempoComponent {}
